
import React from 'react';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { StudentList } from '@/components/admin/StudentList';
import { useStudentList } from '@/hooks/useStudentList';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';

const AdminStudentListPage: React.FC = () => {
  const {
    students,
    isLoading,
    currentPage,
    totalPages,
    searchQuery,
    sortField,
    sortOrder,
    handleSearch,
    handlePageChange,
    handleSort,
  } = useStudentList({ limit: 10 });

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold">รายชื่อนักเรียนทั้งหมด</h1>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <StudentList
                students={students}
                isLoading={isLoading}
                currentPage={currentPage}
                totalPages={totalPages}
                searchQuery={searchQuery}
                sortField={sortField}
                sortOrder={sortOrder}
                onSearch={handleSearch}
                onPageChange={handlePageChange}
                onSort={handleSort}
              />
            </div>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminStudentListPage;
